import { TableCell, TableRow } from "../../../../components/ui/common/table";
import { cn } from "../../../../lib/utils";
import { ClimateImpactFormatter } from "../services/ClimateImpactFormatter";
import { IngredientRowViewModel } from "../types/ingredientListView.types";
import IngredientDataTypeBadge from "./IngredientDataTypeBadge";
import IngredientRowActions from "./IngredientRowActions";
import { ingredientTableColumnClass } from "./ingredientTable.columns";

interface IngredientTableRowProps {
  row: IngredientRowViewModel;
  isUserSupplier: boolean;
  onView: (row: IngredientRowViewModel) => void;
  onEdit: (row: IngredientRowViewModel) => void;
  onDelete: (row: IngredientRowViewModel) => void;
}

const unitSizeText = (row: IngredientRowViewModel) => {
  const { unit_size, unit_type } = row.supplierIngredientDetails || {};
  if (!unit_size && !unit_type) {
    return "";
  }
  return `${unit_size ?? ""} ${unit_type ?? ""}`.trim();
};

const IngredientTableRow = ({
  row,
  isUserSupplier,
  onView,
  onEdit,
  onDelete
}: IngredientTableRowProps) => {
  return (
    <TableRow className="tw-bg-white hover:tw-bg-muted/50">
      <TableCell className={ingredientTableColumnClass.name}>
        <div className="tw-font-medium tw-text-foreground">{row.ingredient_name}</div>
        {row.supplierIngredientDetails?.ingredient_type ? (
          <div className="tw-text-xs tw-uppercase tw-tracking-wide tw-text-muted-foreground">
            {row.supplierIngredientDetails.ingredient_type}
          </div>
        ) : null}
      </TableCell>
      <TableCell className={cn(ingredientTableColumnClass.supplier, "tw-text-foreground")}>
        {row.supplier_name || ""}
      </TableCell>
      <TableCell className={cn(ingredientTableColumnClass.unitSize, "tw-text-foreground")}>
        {unitSizeText(row)}
      </TableCell>
      <TableCell className={cn(ingredientTableColumnClass.climateImpact, "tw-text-foreground")}>
        {ClimateImpactFormatter.format(row, isUserSupplier)}
      </TableCell>
      <TableCell className={ingredientTableColumnClass.dataType}>
        <IngredientDataTypeBadge row={row} />
      </TableCell>
      <TableCell className={ingredientTableColumnClass.actions}>
        <IngredientRowActions row={row} onView={onView} onEdit={onEdit} onDelete={onDelete} />
      </TableCell>
    </TableRow>
  );
};

export default IngredientTableRow;
